import { render, staticRenderFns } from "./Leverdag.vue?vue&type=template&id=55fcd1f3&scoped=true&"
import script from "./Leverdag.vue?vue&type=script&lang=js&"
export * from "./Leverdag.vue?vue&type=script&lang=js&"
import style0 from "./Leverdag.vue?vue&type=style&index=0&id=55fcd1f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fcd1f3",
  null
  
)

export default component.exports